import { atom } from 'jotai';
import Cookies from 'js-cookie';

const isAuthenticated = () => {
  const token = Cookies.get('access_token');
  return !!token;
};

export const isLoggedInAtom = atom(isAuthenticated());
